module.exports = __webpack_public_path__ + "static/media/icon3.f803daef.svg";